var {AmpersandState} = require('catalog/libs');

/**
 * Dynamic Tab Container Interface
 * inherit from this to implement inteface child of the dynamic tab container
 */
var HPEServices = require('../../base/hpe.services');
var HPEConstants = require('../../base/hpe.constants');

module.exports = AmpersandState.extend({

    /**
     * component initialization called only once (after Ampersand initialize())
     * extend to perform aditional initialization
     * always return this
     * @param {object} options configuration options (should include "el" value as required DOM element reference to attach view to)
     */
    init: function(options) {
        options = options || {};

        if (this.view && this.model) {

            //use passed document element for rendering if provided
            if (options.servicePath) {
                this.model.url = options.servicePath;
            }

            //use passed document element for rendering
            if (options.el) {
                this.view.el = options.el;
            }
            this.view.render();
        }

        HPEServices.publish(HPEConstants.dynamictabcontainer.CHILDINIT, this);
        return this;
    },

    /**
     * destroy the view
     * extend to perform additional cleanup, remove events, abort XHR, etc
     */
    destroyView: function() {
        if (this.view) {
            this.view.remove();
        }
    },

    /**
     * render the view
     * extend to add additional view initialization, etc
     * @param  {object} el required DOM element reference to attach view to
     */
    render: function(el) {
        if (this.view) {
            this.view.el = el;
            this.view.render();
        }
    }
});
